import React from "react";
import { Button, GrayText, RightDiv, Separator } from "@atlassiansox/microscopekit";
import { parseDateTime } from "../utils/Utils";
import { ButtonGroup, LoadingButton } from "@atlaskit/button";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import NotificationRemoveQuery from "../graphql/service-notification-remove.mutation.graphql";
import { useMutationUI } from "../hooks";
var NotificationDetailComponent = function (props) {
    var _a = useMutationUI({
        mutation: NotificationRemoveQuery,
        successMessage: "Notifications disabled successfully",
        options: {
            variables: {
                id: props.serviceNotification.id
            },
            onCompleted: function () { return props.setServiceNotification(undefined); }
        }
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return (React.createElement("div", null,
        React.createElement(RightDiv, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { appearance: "primary", onClick: function (event) {
                        props.setIsEditMode(true);
                    }, iconBefore: EditFilledIcon }, "Edit"),
                React.createElement(LoadingButton, { appearance: "danger", isLoading: isLoading, onClick: function () { return mutate(); } }, "Delete"))),
        React.createElement("h3", null,
            "#",
            props.serviceNotification.channel),
        React.createElement("p", null, "You have subscribed for the following events"),
        React.createElement("ul", null, props.serviceNotification.subscriptions.map(function (val) { return (React.createElement("li", null, val)); })),
        React.createElement(Separator, null),
        React.createElement(GrayText, null,
            React.createElement("i", null,
                "Last updated at ",
                parseDateTime(props.serviceNotification.updatedAt)))));
};
export var NotificationDetailView = NotificationDetailComponent;
